import { AutoMap } from "@automapper/classes";
import { BaseModel } from "../base/base.model";
import { createMap, forMember, mapFrom, mapWith, } from '@automapper/core';
import { mapper } from "src/app/infrastructure/infrastructure-services/common/mapper";
import { audit } from "rxjs";
import { CommonEnumData, CommonFilterModel } from "src/app/infrastructure/infrastructure-services/common/models/wrapper.model";

export class JournalModel implements IjournalModel {

  @AutoMap() series: string = "";
  @AutoMap() seriesName: string = "";
  @AutoMap(() => Attachments2_LinesModel)
  Attachments2_Lines: Attachments2_LinesModel[] = [];
  @AutoMap() attachmentEntry: string | null = null;
  @AutoMap() locked:string="";
  @AutoMap() jdtNum: number = 0;
  @AutoMap() document:string="";
  @AutoMap() number: number = 0;
  @AutoMap() referenceDate: string = "";;
  @AutoMap() dueDate: string = "";;
  @AutoMap() taxDate: string = "";;
  @AutoMap() memo: string = "";;
  @AutoMap() transType: string = "";;
  @AutoMap() transTypeName: string = "";
  @AutoMap() baseReference: string = "";
  @AutoMap() projectCode: string = "";;
  @AutoMap() reference: string = "";;
  @AutoMap() reference2: string = "";;
  @AutoMap() reference3: string = "";;
  @AutoMap() bplId: number = 0;
  @AutoMap() bplName: string = "";;
  @AutoMap() locationCode: string = "";;
  @AutoMap() locationName: string = "";;
  @AutoMap() creator: string = "";
  @AutoMap(() => DocumentLinesModel) documentLines: DocumentLinesModel[] = [];
  // constructor() {
  //   createMap(mapper, JournalModel, JournalModelSAP,
  //     forMember(
  //         (destination) => destination.Series,
  //         mapFrom((source) => source.series)
  //     ),
  //     forMember(
  //         (destination) => destination.AttachmentEntry,
  //         mapFrom((source) => source.attachmentEntry)
  //     ),
  //     forMember(
  //       (destination) => destination.JdtNum,
  //       mapFrom((source) => source.jdtNum)
  //     ),
  //     forMember(
  //         (destination) => destination.Number,
  //         mapFrom((source) => source.number)
  //     ),
  //     forMember(
  //         (destination) => destination.ReferenceDate,
  //         mapFrom((source) => source.referenceDate)
  //     ),
  //     forMember(
  //         (destination) => destination.DueDate,
  //         mapFrom((source) => source.dueDate)
  //     ),
  //     forMember(
  //         (destination) => destination.TaxDate,
  //         mapFrom((source) => source.taxDate)
  //     ),
  //     forMember(
  //         (destination) => destination.Memo,
  //         mapFrom((source) => source.memo)
  //     ),
  //     forMember(
  //       (destination) => destination.BaseReference,
  //       mapFrom((source) => source.baseReference)
  //     ),
  //     forMember(
  //       (destination) => destination.ProjectCode,
  //       mapFrom((source) => source.projectCode)
  //     ),
  //     forMember(
  //       (destination) => destination.Reference,
  //       mapFrom((source) => source.reference)
  //     ),
  //     forMember(
  //       (destination) => destination.Reference2,
  //       mapFrom((source) => source.reference2)
  //     ),
  //     forMember(
  //       (destination) => destination.Reference3,
  //       mapFrom((source) => source.reference3)
  //     ),
  //     forMember(
  //       (destination) => destination.LocationCode,
  //       mapFrom((source) => source.locationCode)
  //     ),
  //     forMember(
  //       (destination) => destination.JournalEntryLines,
  //       mapWith(DocumentLinesModelSAP, DocumentLinesModel, (source) => source.documentLines)
  //     )
  //   );
  // }
}

export class JournalModelSAP implements IjournalModelSAP {
  @AutoMap() Series: string = "";
  @AutoMap() AttachmentEntry: string | null = null;
  
  // @AutoMap(() => Attachments2_LinesModel)
  // Attachments2_Lines: Attachments2_LinesModel[] = [];
  

  @AutoMap() JdtNum: number = 0;

  @AutoMap() Number: number = 0;
  @AutoMap() ReferenceDate: string | null= null;
;
  @AutoMap() DueDate: string |  null= null;
  @AutoMap() TaxDate: string | null = null;
  @AutoMap() Memo: string = "";;
  // @AutoMap() TransType: string = "";;
  // @AutoMap() TransTypeName: string = "";
  @AutoMap() BaseReference: string = "";
  @AutoMap() ProjectCode: string = "";;
  @AutoMap() Reference: string = "";;
  @AutoMap() Reference2: string = "";;
  @AutoMap() Reference3: string = "";;
  // @AutoMap() BplId: number = 0;
  // @AutoMap() BplName: string = "";;
  @AutoMap() LocationCode: string = "";;
 // @AutoMap() LocationName: string = "";;
  // @AutoMap() Creator: string = "";
   @AutoMap(() => DocumentLinesModelSAP) JournalEntryLines: DocumentLinesModelSAP[] = [];
  
  constructor() {
    createMap(mapper, DocumentLinesModel, DocumentLinesModelSAP);
    createMap(mapper, JournalModel, JournalModelSAP,
      forMember(
          (destination) => destination.Series,
          mapFrom((source) => source.series)
      ),
      forMember(
          (destination) => destination.AttachmentEntry,
          mapFrom((source) => source.attachmentEntry)
      ),
      forMember(
        (destination) => destination.JdtNum,
        mapFrom((source) => source.jdtNum)
      ),
      forMember(
          (destination) => destination.Number,
          mapFrom((source) => source.number)
      ),
      forMember(
          (destination) => destination.ReferenceDate,
          mapFrom((source) => source.referenceDate)
      ),
      forMember(
          (destination) => destination.DueDate,
          mapFrom((source) => source.dueDate)
      ),
      forMember(
          (destination) => destination.TaxDate,
          mapFrom((source) => source.taxDate)
      ),
      forMember(
          (destination) => destination.Memo,
          mapFrom((source) => source.memo)
      ),
      forMember(
        (destination) => destination.BaseReference,
        mapFrom((source) => source.baseReference)
      ),
      forMember(
        (destination) => destination.ProjectCode,
        mapFrom((source) => source.projectCode)
      ),
      forMember(
        (destination) => destination.Reference,
        mapFrom((source) => source.reference)
      ),
      forMember(
        (destination) => destination.Reference2,
        mapFrom((source) => source.reference2)
      ),
      forMember(
        (destination) => destination.Reference3,
        mapFrom((source) => source.reference3)
      ),
      forMember(
        (destination) => destination.LocationCode,
        mapFrom((source) => source.locationCode)
      ),
       forMember(
        (destination) => destination.JournalEntryLines,
        mapWith(DocumentLinesModelSAP, DocumentLinesModel, (source) => source.documentLines)
      )
    );
  }
}

export class DocumentLinesModelSAP implements IDocumentLinesModelSAP {
  @AutoMap() Line_ID: number = 0;
;
  //@AutoMap() TransId: number = 0;;
  @AutoMap() Debit: number = 0;
  @AutoMap() Credit: number = 0;
  @AutoMap() BPLID: number = 0;
  @AutoMap() BPLName: string = "";
  @AutoMap() AccountCode: string = "";
 @AutoMap() ShortName: string = "";
  // @AutoMap() BaseRef: string = "";
  @AutoMap() ReferenceDate1: string = "";
  @AutoMap() DueDate: string = "";
  @AutoMap() TaxDate: string = "";
  @AutoMap() Reference1: string = "";
  @AutoMap() Reference2: string = "";
//  @AutoMap() Ref3Line: string = "";
  @AutoMap() LineMemo: string = "";
  @AutoMap() ControlAccount: string = "";
  @AutoMap() LocationCode: string = "";
 // @AutoMap() LocationName: string = "";
  @AutoMap() ProjectCode: string = "";
  constructor() {
    createMap(mapper, DocumentLinesModel, DocumentLinesModelSAP,
      forMember(
        (destination) => destination.Line_ID,
        mapFrom((source) => source.line_ID)
      ),
      // forMember(
      //   (destination) => destination.TransId,
      //   mapFrom((source) => source.transId)
      // ),
      forMember(
        (destination) => destination.Debit,
        mapFrom((source) => source.debit)
      ),
      forMember(
        (destination) => destination.Credit,
        mapFrom((source) => source.credit)
      ),

      forMember(
        (destination) => destination.BPLID,
        mapFrom((source) => source.bplid)
      ),
      forMember(
        (destination) => destination.BPLName,
        mapFrom((source) => source.bplName)
      ),
      forMember(
        (destination) => destination.AccountCode,
        mapFrom((source) => source.accountCode)
      ),

      forMember(
        (destination) => destination.ProjectCode,
        mapFrom((source) => source.projectCode)
      ),
      forMember(
        (destination) => destination.ReferenceDate1,
        mapFrom((source) => source.referenceDate1)
      ),
      forMember(
        (destination) => destination.DueDate,
        mapFrom((source) => source.dueDate)
      ),
      forMember(
        (destination) => destination.TaxDate,
        mapFrom((source) => source.taxDate)
      ),
      forMember(
        (destination) => destination.Reference1,
        mapFrom((source) => source.ref1)
      ),
      forMember(
        (destination) => destination.Reference2,
        mapFrom((source) => source.ref2)
      ),
      forMember(
        (destination) => destination.LineMemo,
        mapFrom((source) => source.lineMemo)
      ),
      forMember(
        (destination) => destination.ControlAccount,
        mapFrom((source) => source.controlAccount)
      ),
      forMember(
        (destination) => destination.LocationCode,
        mapFrom((source) => source.locationCode)
      ),
      // forMember(
      //   (destination) => destination.LocationName,
      //   mapFrom((source) => source.locationName)
      // ),
      forMember(
        (destination) => destination.ProjectCode,
        mapFrom((source) => source.projectCode)
      )
    );
  }

}

export interface IjournalModel extends BaseModel {
  series: string,
  seriesName: string,
  Attachments2_Lines: IAttachments2_LinesModel[]
  attachmentEntry: string | null;
  jdtNum: number;
document:string;
  number: number;
  referenceDate: string;
  dueDate: string;
  taxDate: string;
  memo: string;
  transType: string;
  transTypeName: string,
  baseReference: string;
  projectCode: string;
  reference: string;
  reference2: string;
  reference3: string;
  bplId: number;
  bplName: string;
  locationCode: string;
  locationName: string;
  creator: string;
  documentLines: IDocumentLinesModel[];
  locked:string;
}

export interface IjournalModelSAP {
  Series: string;
  AttachmentEntry: string | null;
  JournalEntryLines: IDocumentLinesModelSAP[];
  
  // Attachments2_Lines: IAttachments2_LinesModel[]
 
  JdtNum: number;

  Number: number;
  ReferenceDate: string | null;
  DueDate: string | null;
  TaxDate: string | null;
  Memo: string;
  // TransType: string;
  // TransTypeName: string,
  BaseReference: string;
  ProjectCode: string;
  Reference: string;
  Reference2: string;
  Reference3: string;
  // BplId: number;
  // BplName: string;
  LocationCode: string;
//  LocationName: string;
  // Creator: string;
  

}

// export interface IAllEnumData {
//   accountType: CommonFilterModel[];
//   accounts: CommonFilterModel[];
// }

// export class AllEnumdata extends CommonEnumData implements IAllEnumData {
//   @AutoMap() accountType: CommonFilterModel[] = [];
//   @AutoMap() accounts: CommonFilterModel[] = [];
// }
export interface IAttachments2_LinesModel {
  AbsoluteEntry: number,
  LineNum: number,
  SourcePath: string
  FileName: string
  FileExtension: string
  AttachmentDate: string
}
export class Attachments2_LinesModel implements IAttachments2_LinesModel {
  AbsoluteEntry!: number
  LineNum!: number
  SourcePath: string = ""
  FileName: string = ""
  FileExtension: string = ""
  AttachmentDate: string = ""
}

export interface IDocumentLinesModel {

  line_ID: number;
  transId: number;
  debit: number;
  credit: number;
  bplid: number;
  bplName: string;
  account?: string;
  shortName: string;
  baseRef: string;
  referenceDate1: string;
  dueDate: string;
  taxDate: string;
  ref1: string;
  ref2: string;
  ref3Line: string;
  lineMemo: string;
  controlAccount: string;
  locationCode: string;
  locationName: string;
  projectCode: string;
  accountCode:string;
  accountName:string;
}
export class DocumentLinesModel implements IDocumentLinesModel {

  @AutoMap() line_ID: number = 0;;
  @AutoMap() transId: number = 0;;
  @AutoMap() debit: number = 0;
  @AutoMap() credit: number = 0;
  @AutoMap() bplid: number = 0;
  @AutoMap() bplName: string = "";
  @AutoMap() account?: string = "";
  @AutoMap() shortName: string = "";
  @AutoMap() baseRef: string = "";
  @AutoMap() referenceDate1: string = "";
  @AutoMap() dueDate: string = "";
  @AutoMap() taxDate: string = "";
  @AutoMap() ref1: string = "";
  @AutoMap() ref2: string = "";
  @AutoMap() ref3Line: string = "";
  @AutoMap() lineMemo: string = "";
  @AutoMap() controlAccount: string = "";
  @AutoMap() locationCode: string = "";
  @AutoMap() locationName: string = "";
  @AutoMap() projectCode: string = "";
  @AutoMap() accountCode: string = ""; 
@AutoMap() accountName :string ="";
constructor() {
  createMap(mapper, DocumentLinesModel, DocumentLinesModelSAP,
    forMember(
      (destination) => destination.Line_ID,
      mapFrom((source) => source.line_ID)
    ),
    // forMember(
    //   (destination) => destination.TransId,
    //   mapFrom((source) => source.transId)
    // ),
    forMember(
      (destination) => destination.Debit,
      mapFrom((source) => source.debit)
    ),
    forMember(
      (destination) => destination.Credit,
      mapFrom((source) => source.credit)
    ),

    forMember(
      (destination) => destination.BPLID,
      mapFrom((source) => source.bplid)
    ),
    forMember(
      (destination) => destination.BPLName,
      mapFrom((source) => source.bplName)
    ),
    forMember(
      (destination) => destination.AccountCode,
      mapFrom((source) => source.accountCode)
    ),

    forMember(
      (destination) => destination.ShortName,
      mapFrom((source) => source.shortName)
    ),

    forMember(
      (destination) => destination.ProjectCode,
      mapFrom((source) => source.projectCode)
    ),
    // forMember(
    //   (destination) => destination.BaseRef,
    //   mapFrom((source) => source.baseRef)
    // ),
    forMember(
      (destination) => destination.ReferenceDate1,
      mapFrom((source) => source.referenceDate1)
    ),
    forMember(
      (destination) => destination.DueDate,
      mapFrom((source) => source.dueDate)
    ),
    forMember(
      (destination) => destination.TaxDate,
      mapFrom((source) => source.taxDate)
    ),
    forMember(
      (destination) => destination.Reference1,
      mapFrom((source) => source.ref1)
    ),
    forMember(
      (destination) => destination.Reference2,
      mapFrom((source) => source.ref2)
    ),
    // forMember(
    //   (destination) => destination.Ref3Line,
    //   mapFrom((source) => source.ref3Line)
    // ),
    forMember(
      (destination) => destination.LineMemo,
      mapFrom((source) => source.lineMemo)
    ),
    forMember(
      (destination) => destination.ControlAccount,
      mapFrom((source) => source.controlAccount)
    ),
    forMember(
      (destination) => destination.LocationCode,
      mapFrom((source) => source.locationCode)
    ),
    forMember(
      (destination) => destination.ProjectCode,
      mapFrom((source) => source.projectCode)
    )
  );
}
}

export interface IDocumentLinesModelSAP {
  Line_ID: number;
 // TransId: number;
  Debit: number;
  Credit: number;
  BPLID: number;
  BPLName: string;
  // Account: string;
  ShortName: string;
  // BaseRef: string;
  ReferenceDate1: string;
  DueDate: string;
  TaxDate: string;
  Reference1: string;
  Reference2: string;
  // Ref3Line: string;
  LineMemo: string;
  ControlAccount: string;
  LocationCode: string;
  ProjectCode: string;
  AccountCode:string;
}